<div class="pagination pt-2 pb-2">
  <div class="pagination__item" *ngIf="firstPage > 0">
    <svg-icon key="arrow-back" [color]="'#4F4F4F'" (click)="previousPage()" class="mr-1.5 cursor-pointer"
      size="lg"></svg-icon>
  </div>
  <div *ngFor="let exercise of paginationActivity.exercises | slice: firstPage : lastPage"
    class="pagination__tooltip flex flex-col items-center">
    <li class="pagination__item rounded font-medium" [ngClass]="[
        exercise.isHidden ? '' : 'cursor-pointer',
        selectedPage === exercise.number ? selectedClass : '',
        !isTeacher &&
        (exercise.status === PageActivityStatus.COMPLETED || exercise.status === PageActivityStatus.SAVED) &&
        selectedPage !== exercise.number &&
        !paginationActivity.isSent
          ? 'bg-opacity-30 ' + selectedClass
          : '',
      ]" (click)="pageChange(exercise)">
      <span [ngClass]="[
          exercise.isHidden ? 'text-disabled' : '',
          !isTeacher &&
          (exercise.status === PageActivityStatus.COMPLETED || exercise.status === PageActivityStatus.SAVED) &&
          selectedPage !== exercise.number
            ? 'text-black'
            : '',
        ]">{{ exercise.number }}</span>
    </li>
    <onmat-teacher-settings [exercise]="exercise" (visibilityEmitter)="clickOnVisibility($event)">
    </onmat-teacher-settings>
  </div>
  @if (MAX_EXERCISES_INLINE < paginationActivity.exercises.length && lastPage < paginationActivity.exercises.length) {
    <div class="pagination__item">
    <svg-icon key="arrow-forward" [color]="'#4F4F4F'" (click)="nextPage()" class="cursor-pointer" size="lg"></svg-icon>
</div>
}
</div>

@if (paginationActivity.isEvaluable) {
@if (showProgress) {
<div class="w-full flex pb-2 bg-white">
  @if (firstPage > 0) {
  <div class="wrapper"></div>
  }
  @for (exercise of paginationActivity.exercises.slice(firstPage, lastPage); track exercise.id; let i = $index) {
  <div class="flex items-center">
    <onmat-student-progress [exercise]="exercise" [completedStatusClass]="completedStatusClass"
      [incompletedStatusClass]="incompletedStatusClass" [toDoStatusClass]="toDoStatusClass"
      [paginationActivity]="paginationActivity"></onmat-student-progress>
  </div>
  }
</div>
}
}

<hr class="border-dashed bg-white" />